const baseUrl = "https://irm.aquasense.tech/api"; // Corrected IP address

export default baseUrl;
